import './CardOptions.scss';
import master from '../../../assets/master_logo.png';
import visa from '../../../assets/visa_logo.png';
import amex from '../../../assets/express_logo.png';
import { useState } from 'react';
import { TransactionDetails } from '../../../types/api.types';
import { CardElement } from '../CardElement/CardElement';
import { Cybersource } from '../../Cybersource/Cybersource';
import { AmexOld } from '../../AmexOld/AmexOld';
export interface CardOptions {
  details: TransactionDetails;
  response: any;
}
export const CardOptions = ({ details, response }: CardOptions) => {
  const [type, setType] = useState('');

  const optionSelection = (type: string) => {
    setType(type);
  };

  // Helper function to check if a provider key exists in both old and new formats
  const hasProviderKey = (keyToCheck: string): boolean => {
    if (
      !details.data.provider_keys ||
      !Array.isArray(details.data.provider_keys)
    ) {
      return false;
    }

    // Handle new format (array of objects)
    if (
      details.data.provider_keys.length > 0 &&
      typeof details.data.provider_keys[0] === 'object'
    ) {
      const providerKeys = details.data.provider_keys as Array<{
        id: number;
        key: string;
      }>;
      return providerKeys.some((provider) => provider.key === keyToCheck);
    }

    // Handle old format (array of strings)
    const providerKeys = details.data.provider_keys as Array<string>;
    return providerKeys.includes(keyToCheck);
  };

  const hasAmexOption =
    hasProviderKey('NTB-AMEX-LKR') ||
    hasProviderKey('NTB-AMEX-USD') ||
    hasProviderKey('AMEX') ||
    hasProviderKey('AMEX-USD');

  return (
    <div>
      {type === '' && (
        <>
          <div className="row">
            <div className="col-6 ps-4 pe-4 pt-4">
              <div
                className="card-option d-flex justify-content-center align-items-center"
                onClick={() => optionSelection('mpgs')}
              >
                <img src={master} width={'37.57px'} alt="master" />
              </div>
            </div>

            <div className="col-6 ps-4 pe-4 pt-4">
              <div
                className="card-option d-flex justify-content-center align-items-center"
                onClick={() => optionSelection('mpgs')}
              >
                <img src={visa} width={'37.57px'} alt="visa" />
              </div>
            </div>
          </div>

          {hasAmexOption && (
            <div className="row d-flex justify-content-center">
              <div className="col-6 p-4">
                <div
                  className="card-option d-flex justify-content-center align-items-center"
                  onClick={() => optionSelection('amex')}
                >
                  <img src={amex} width={'37.57px'} alt="amex" />
                </div>
              </div>
            </div>
          )}
        </>
      )}
      {type &&
        type === 'mpgs' &&
        !hasProviderKey('CYBERSOURCE') &&
        !hasProviderKey('CYBERSOURCE-USD') && (
          <CardElement response={response} />
        )}

      {type &&
        type === 'mpgs' &&
        (hasProviderKey('CYBERSOURCE') ||
          hasProviderKey('CYBERSOURCE-USD')) && <Cybersource />}

      {type &&
        type === 'amex' &&
        (hasProviderKey('NTB-AMEX-LKR') || hasProviderKey('NTB-AMEX-USD')) && (
          <CardElement response={response} />
        )}

      {type &&
        type === 'amex' &&
        (hasProviderKey('AMEX') || hasProviderKey('AMEX-USD')) && <AmexOld />}
    </div>
  );
};
